import React from 'react';
import PropTypes from 'prop-types';
import { Grid, withStyles } from 'material-ui';
import { Field, Form } from 'redux-form';
import Table, { TableBody, TableCell, TableRow } from 'material-ui/Table';
import {
  TextInput,
  Checkbox,
  formatCurrency,
  paymentMethods,
  paymentTypes,
} from 'entoro-shared';
import ImageInput from './ImageInput';

const styles = {
  headerHR: {
    borderBottom: '1px solid #4d5e75',
  },
  title: {
    fontSize: '16px',
    margin: 0,
  },
  labelCell: {
    fontWeight: 700,
    border: 'none',
    width: '200px',
    fontSize: '14px',
  },
  cell: {
    border: 'none',
    fontSize: '14px',
  },
  subheading: {
    color: '#8c8c8c',
    fontWeight: '300',
  },
};

const PaymentVerification = ({
  disabled,
  offer,
  initialValues,
  handleSubmit,
  classes,
  selectedPaymentType,
}) => {
  const cryptoType = selectedPaymentType.replace('CRYPTO_', '').toLowerCase();
  const cryptoWallet = `${cryptoType}WalletAddress`;
  const cryptoWalletAddress = offer.paymentDetails[cryptoWallet];

  return (
    <div className='step'>
      {initialValues.paymentMethod === 'CRYPTO' && (
        <Grid container spacing={16} direction='row'>
          <Grid item xs={12} className={classes.headerHR}>
            <p className={classes.title}>Payment Details</p>
          </Grid>
          <Grid item xs={12}>
            <Table>
              <TableBody>
                <TableRow className={classes.row}>
                  <TableCell className={classes.labelCell}>
                    Payment Method:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {paymentMethods.getLabel(initialValues.paymentMethod)}
                  </TableCell>
                </TableRow>
                <TableRow className={classes.row}>
                  <TableCell className={classes.labelCell}>
                    Payment Type:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {paymentTypes.getLabel(initialValues.paymentType)}
                  </TableCell>
                </TableRow>
                <TableRow className={classes.row}>
                  <TableCell className={classes.labelCell}>
                    Payment Amount:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {formatCurrency(initialValues.investmentAmount)}
                    <br />
                    <i>
                      {initialValues.investmentAmountCrypto}
                      {paymentTypes.getLabel(initialValues.paymentType)}
                    </i>
                  </TableCell>
                </TableRow>
                <TableRow className={classes.row}>
                  <TableCell className={classes.labelCell}>
                    Wallet Address:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {cryptoWalletAddress}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12}>
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={16} direction='row'>
                <Grid item xs={12} className={classes.headerHR}>
                  <p className={classes.title}>Transaction ID</p>
                </Grid>
                <Grid item xs={12}>
                  <p className={classes.subheading}>
                    To confirm your transaction, please provider your
                    transaction ID number and upload the receipt.
                  </p>
                </Grid>
                <Grid item xs={12}>
                  <p className={classes.subheading}>
                    Enter in the Transaction ID
                  </p>
                  <Field
                    disabled={disabled}
                    component={TextInput}
                    name='transactionId'
                  />
                </Grid>
              </Grid>
            </Form>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={16} direction='row'>
              <Grid item xs={12}>
                <p className={classes.subheading}>
                  {initialValues.receiptImageId
                    ? 'Transaction receipt'
                    : 'Please upload your transaction receipt'}
                </p>
                <ImageInput source='receiptImageId' />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {initialValues.paymentMethod === 'BANK' && (
        <Grid container spacing={16} direction='row'>
          <Grid item xs={12} className={classes.headerHR}>
            <p className={classes.title}>Payment Details</p>
          </Grid>
          <Grid item xs={12}>
            <Table>
              <TableBody>
                <TableRow className={classes.row}>
                  <TableCell className={classes.labelCell}>
                    Payment Method:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {paymentMethods.getLabel(initialValues.paymentMethod)}
                  </TableCell>
                </TableRow>
                <TableRow className={classes.row}>
                  <TableCell className={classes.labelCell}>
                    Payment Type:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {paymentTypes.getLabel(initialValues.paymentType)}
                  </TableCell>
                </TableRow>
                <TableRow className={classes.row}>
                  <TableCell className={classes.labelCell}>
                    Payment Amount:
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {formatCurrency(initialValues.investmentAmount)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={16} direction='row'>
              <Grid item xs={12}>
                <p className={classes.subheading}>
                  {initialValues.receiptImageId
                    ? 'Transaction receipt'
                    : 'Please upload your transaction receipt'}
                </p>
                <ImageInput source='receiptImageId' />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      <br />
      <Field
        disabled={disabled}
        component={Checkbox}
        name='paymentSent'
        label='Mark as Payment Sent'
      />
    </div>
  );
};

PaymentVerification.propTypes = {
  classes: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  selectedPaymentType: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default withStyles(styles)(PaymentVerification);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/PaymentVerification.js